import React, { useState, useEffect, useCallback } from 'react';
import Notification from '../../components/Notification';
import useApi from '../../api/useApi';
import CreateEvent from '../../components/CreateEvent';

function Events() {
  const [openCreate, setOpenCreate] = useState(false);
  const [notification, setNotification] = useState(false);
  const [type, setType] = useState(null);
  const [message, setMessage] = useState(null);
  const [selectedEvent, selectEvent] = useState(1);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [deviceTypes, setDeviceTypes] = useState([]);
  const [formData, setFormData] = useState({ q: '', status: '' });

  const [{ isLoading, isError, data }, getEvent] = useApi();
  const [deleteRes, deleteEvent] = useApi();
  const [deviceTypeRes, getDeviceTypes] = useApi();

  useEffect(() => {
    getEvent(`/events`, 'GET');
    getDeviceTypes('/deviceTypes', 'GET');
  }, []);

  useEffect(() => {
    if (isError) {
      setType('error');
      setMessage('Unable to fetch Events');
      setNotification(!notification);
    }
  }, [isLoading, isError, data]);

  useEffect(() => {
    if (!deviceTypeRes.isLoading && !deviceTypeRes.isError && deviceTypeRes.data) {
      setDeviceTypes(deviceTypeRes?.data?.deviceTypes || []);
    }
  }, [deviceTypeRes.isLoading, deviceTypeRes.isError, deviceTypeRes.data]);

  const handleClose = (refresh = false) => {
    setOpenCreate(false);
    selectEvent(null);
    if (refresh) getEvent(`/events`, 'GET');
  };

  const handleDelete = () => {
    deleteEvent(`/events/${selectedEvent.id}`, 'DELETE');
  };

  useEffect(() => {
    if (!deleteRes.isLoading && !deleteRes.isError && deleteRes.data) {
      getEvent(`/events`, 'GET');
      setType('success');
      setMessage('Event Deleted Successfully');
      setNotification(!notification);
      setOpenConfirm(false);
      selectEvent(null);
    }
    if (deleteRes.isError) {
      setType('error');
      setMessage('Unable to Delete Event');
      setNotification(!notification);
    }
  }, [deleteRes]);

  const hideNotification = (msg) => {
    setNotification(false);
  };

  const createNotification = (types, messages) => {
    setType(types);
    setMessage(messages);
    setNotification(!notification);
  };

  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));

  let _data = data?.events || [];

  if (formData.q) {
    _data = _data.filter((event) => event.name.toLowerCase().includes(formData.q.toLowerCase()));
  }

  return (
    <>
      {notification && <Notification type={type} message={message} hideNotification={hideNotification} />}
      {openConfirm && (
        <div
          className="flex justify-center items-center h-full w-full fixed z-20"
          style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
        >
          <div className="bg-white w-full sm:w-3/12 text-sm block m-auto rounded-2xl relative pb-6">
            <div className="p-4 flex justify-between items-center border-b">
              <span className="font-bold  text-textBlue1">Delete Device</span>
              <img
                src="assets/img/Close.svg"
                className=" h-3 cursor-pointer"
                alt=""
                onClick={() => setOpenConfirm(false)}
              />
            </div>
            <span className="block text-center text-sm my-8 text-parameter">
              Do you want to delete Event <span className="text-black font-medium">{selectedEvent.name}</span>?
            </span>
            {deleteRes.isLoading ? (
              <div className="flex justify-center items-center">
                <img src="assets/img/loader.svg" className="w-12 mx-auto" alt="" />
              </div>
            ) : (
              <div className="flex justify-center items-center gap-x-3">
                <button
                  className="mt-1 lg:mt-0 lg:w-1/4 w-auto border px-8 rounded-3xl text-xs mr-2 focus:outline-none flex justify-center items-center py-2"
                  onClick={() => {
                    setOpenConfirm(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="mt-1 lg:mt-0 w-auto lg:w-1/4 border px-8 rounded-3xl text-xs font-bold focus:outline-none flex justify-center items-center py-2 bg-btnBg text-white"
                  onClick={handleDelete}
                >
                  Confirm
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {openCreate && (
        <CreateEvent
          handleClose={handleClose}
          notification={createNotification}
          selectedEventId={selectedEvent?.id}
          deviceTypes={deviceTypes}
        />
      )}

      <div
        className="mt-10 md:mt-0 lg:m-8 static md:fixed bg-white w-full sm:w-10/12 overflow-scroll lg:overflow-hidden devices nav_devices"
        style={{
          filter: openCreate && 'blur(2px)',
        }}
      >
        <div className="h-16 sm:h-40">
          <div className="pt-4 md:pt-8 lg:flex block sm:block sm:justify-between text-left sm:text-center lg:text-left w-tableWidth m-auto ">
            <span className="text-textBlue1 font-bold text-lg">Events</span>

            <div className="flex mt-0 float-right">
              <button
                className="mt-1 lg:mt-0 w-max border px-3 py-1 rounded-md text-xs mx-0 sm:mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  setOpenCreate(true);
                }}
              >
                <img src="assets/img/Create.svg" className="h-3 mr-2 " alt="" />
                CREATE
              </button>

              <div className="mt-1 lg:mt-0 w-full text-xs lg:w-max border bg-transparent px-3 py-1.5 ml-3 flex justify-between items-center rounded-3xl button_search2 ">
                <input
                  type="text"
                  placeholder="Search"
                  autoComplete="off"
                  className="text-textBox bg-transparent focus:outline-none button_search2"
                  value={formData.q}
                  name="q"
                  onChange={handleInputChange}
                  style={{ borderColor: '#e6e6e6' }}
                  // onKeyDown={(e) => {
                  //   if (e.which === 13) searchData();
                  // }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="tbl">
          <div className="bg-white w-tableWidth m-auto mb-3" style={{ minWidth: '900px' }}>
            <div className="bg-white w-full flex border" style={{ borderColor: '#e6e6e6' }}>
              <div className="px-8 py-3 items-center flex w-full relative bg-primary text-white text-left text-xs font-bold">
                <div className="w-2/12">Name</div>
                <div className="w-3/12">Scope</div>
                <div className="w-2/12">SubScope</div>
                <div className="w-1/12">Recipients</div>
                <div className="w-2/12">Device Type</div>
                <div className="w-1/12">Status</div>
                <div className="w-1/12">ACTION</div>
              </div>
            </div>

            {!isLoading ? (
              <div className="hideScroll" style={{ overflowY: 'scroll', height: '68vh' }}>
                {_data.map((item, idx) => (
                  <div
                    className="my-1 px-8 flex
              relative hover:border-indigo-200 focus-within:border-indigo-200 text-role py-4 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs"
                    style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                  >
                    <div className="w-2/12 truncate pr-3" title={item?.name}>
                      {item?.name}
                    </div>
                    <div className="w-3/12 truncate pr-3" title={item?.scope.join(', ')}>
                      {item?.scope.join(', ')}
                    </div>
                    <div className="w-2/12 truncate pr-3" title={item?.attributes?.subScope || '-'}>
                      {item?.attributes?.subScope || '-'}
                    </div>
                    <div className="w-1/12 truncate pr-3">
                      {!(item?.attributes?.enableRecipients === false) + '' || '-'}
                    </div>
                    <div className="w-2/12 truncate pr-3" title={item?.attributes?.deviceType?.join(', ') || '-'}>
                      {item?.attributes?.deviceType?.join(', ') || '-'}
                    </div>
                    <div className="w-1/12">
                      {item?.isActive ? (
                        <p className="text-green-700"> ACTIVE</p>
                      ) : (
                        <p className="text-red-700"> INACTIVE</p>
                      )}
                    </div>

                    <div className="w-1/12 flex">
                      <img
                        src="assets/img/Edit2.svg"
                        className="h-3 cursor-pointer mr-4 "
                        alt=""
                        onClick={() => {
                          selectEvent(item);
                          setOpenCreate(true);
                        }}
                      />
                      <img
                        src="assets/img/Delete2.svg"
                        className="h-3 cursor-pointer"
                        alt=""
                        onClick={() => {
                          selectEvent(item);
                          setOpenConfirm(true);
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Events;
